module.exports = __webpack_public_path__ + "img/2-bn.d2567e3e.png";